// current selected date
export const UPDATE_CURRENT_DATE = 'UPDATE_CURRENT_DATE'
export const UPDATE_CURRENT_WEEK_DATE = 'UPDATE_CURRENT_WEEK_DATE'

export const FETCH_CURRENT_USER_ETIME = 'FETCH_CURRENT_USER_ETIME'
export const FETCH_CURRENT_USER_ETIME_FAILURE =
    'FETCH_CURRENT_USER_ETIME_FAILURE'
export const ADD_ETIME = 'ADD_ETIME'
export const ADD_ETIME_FAILURE = 'ADD_ETIME_FAILURE'
export const UPDATE_ETIME = 'UPDATE_ETIME'
export const UPDATE_ETIME_FAILURE = 'UPDATE_ETIME_FAILURE'
export const REMOVE_ETIME = 'REMOVE_ETIME'
export const REMOVE_ETIME_FAILURE = 'REMOVE_ETIME_FAILURE'

export const FETCH_SYSTEMLIST = 'FETCH_SYSTEMLIST'
export const FETCH_SYSTEMLIST_FAILURE = 'FETCH_SYSTEMLIST_FAILURE'
export const GEN_TOKEN = 'GEN_TOKEN'
export const GEN_TOKEN_FAILURE = 'GEN_TOKEN_FAILURE'

// Branches
export const FETCH_BRANCHLIST = 'FETCH_BRANCHLIST'
export const FETCH_BRANCHLIST_FAILURE = 'FETCH_BRANCHLIST_FAILURE'
export const SELECT_BRANCHES = 'SELECT_BRANCHES'

// Departments
export const FETCH_DEPARTMENTSLIST = 'FETCH_DEPARTMENTSLIST'
export const FETCH_DEPARTMENTSLIST_FAILURE = 'FETCH_DEPARTMENTSLIST_FAILURE'
export const SELECT_DEPARTMENTS = 'SELECT_DEPARTMENTS'

// Employee
export const FETCH_EMPLOYEE_LIST = 'FETCH_EMPLOYEE_LIST'
export const FETCH_EMPLOYEE_LIST_FAILURE = 'FETCH_EMPLOYEE_LIST_FAILURE'
export const UPDATE_DISPLAY_EMPLOYEE = 'UPDATE_DISPLAY_EMPLOYEE'
export const SELECT_EMPLOYEE = 'SELECT_EMPLOYEE'
export const SELECT_EMPLOYEES = 'SELECT_EMPLOYEES'

// roster user etime
export const FETCH_ROSTER_USER_ETIME = 'FETCH_ROSTER_USER_ETIME'
export const FETCH_UPDATE_ROSTER_USER_ETIME = 'FETCH_UPDATE_ROSTER_USER_ETIME'
export const UPDATE_ROSTER_ETIME = 'UPDATE_ROSTER_ETIME'
export const ADD_ROSTER_ETIME = 'ADD_ROSTER_ETIME'
export const REMOVE_ROSTER_ETIME = 'REMOVE_ROSTER_ETIME'
export const FETCH_ROSTER_USER_ETIME_FAILURE = 'FETCH_ROSTER_USER_ETIME_FAILURE'
export const FETCH_UPDATE_ROSTER_USER_ETIME_FAILURE =
    'FETCH_UPDATE_ROSTER_USER_ETIME_FAILURE'
export const UPDATE_ROSTER_ETIME_FAILURE = 'UPDATE_ROSTER_ETIME_FAILURE'
export const ADD_ROSTER_ETIME_FAILURE = 'ADD_ROSTER_ETIME_FAILURE'
export const REMOVE_ROSTER_ETIME_FAILURE = 'REMOVE_ROSTER_ETIME_FAILURE'
export const UPDATE_DISPLAY_ETIME = 'UPDATE_DISPLAY_ETIME'
export const UPDATE_WAVIEW_DISPLAY_ETIME = 'UPDATE_WAVIEW_DISPLAY_ETIME'
//
export const UPDATE_DISPLAY_ROSTER = 'UPDATE_DISPLAY_ROSTER'
export const UPDATE_DISPLAY_ROSTER_FAILURE = 'UPDATE_DISPLAY_ROSTER_FAILURE'

export const FETCH_ACTION_LIST = 'FETCH_ACTION_LIST'
export const FETCH_ACTION_LIST_FAILURE = 'FETCH_ACTION_LIST_FAILURE'

export const UPDATE_WORK_ABSENCE_EVENTS = 'UPDATE_WORK_ABSENCE_EVENTS'
export const UPDATE_WORK_EVENTS = 'UPDATE_WORK_EVENTS'
export const UPDATE_WORK_EVENTS_FAILURE = 'UPDATE_WORK_EVENTS_FAILURE'
export const UPDATE_ABSENCE_EVENTS = 'UPDATE_ABSENCE_EVENTS'
export const UPDATE_ABSENCE_EVENTS_FAILURE = 'UPDATE_ABSENCE_EVENTS_FAILURE'

export const UPDATE_WEEKLY_REPORT_EVENTS = 'UPDATE_WEEKLY_REPORT_EVENTS'
export const UPDATE_WEEKLY_REPORT_EVENTS_FAILURE =
    'UPDATE_WEEKLY_REPORT_EVENTS_FAILURE'
export const UPDATE_DAILY_REPORT_EVENTS = 'UPDATE_DAILY_REPORT_EVENTS'
export const UPDATE_DAILY_REPORT_EVENTS_FAILURE =
    'UPDATE_DAILY_REPORT_EVENTS_FAILURE'
export const UPDATE_LEAVE_REPORT_EVENTS = 'UPDATE_LEAVE_REPORT_EVENTS'
export const UPDATE_LEAVE_REPORT_EVENTS_FAILURE =
    'UPDATE_LEAVE_REPORT_EVENTS_FAILURE'
export const UPDATE_SUMMARY_REPORT_EVENTS = 'UPDATE_SUMMARY_REPORT_EVENTS'
export const UPDATE_SUMMARY_REPORT_EVENTS_FAILURE =
    'UPDATE_SUMMARY_REPORT_EVENTS_FAILURE'

// weekly report filter
export const FILTER_WEEKLY_REPORT_INFO = 'FILTER_WEEKLY_REPORT_INFO'

// daily report filter
export const FILTER_DAILY_REPORT_INFO = 'FILTER_DAILY_REPORT_INFO'

// leave report filter
export const FILTER_LEAVE_REPORT_INFO = 'FILTER_LEAVE_REPORT_INFO'

// summary report filter
export const FILTER_SUMMARY_REPORT_INFO = 'FILTER_SUMMARY_REPORT_INFO'

// leave report display employees
export const UPDATE_DISPLAY_EMPLOYEE_LEAVERPT =
    'UPDATE_DISPLAY_EMPLOYEE_LEAVERPT'

export const UPDATE_ABSENCE_REPORT_EVENTS = 'UPDATE_ABSENCE_REPORT_EVENTS'
export const UPDATE_WEEKLY_RPT_DISPLAY_ETIME = 'UPDATE_WEEKLY_RPT_DISPLAY_ETIME'
export const UPDATE_DAILY_RPT_DISPLAY_ETIME = 'UPDATE_DAILY_RPT_DISPLAY_ETIME'
export const UPDATE_LEAVE_RPT_DISPLAY_ETIME = 'UPDATE_LEAVE_RPT_DISPLAY_ETIME'
export const UPDATE_SUMMARY_RPT_DISPLAY_ETIME =
    'UPDATE_SUMMARY_RPT_DISPLAY_ETIME'
export const TRANSFORM_SUMMARY_RPT_DISPLAY_ETIME =
    'TRANSFORM_SUMMARY_RPT_DISPLAY_ETIME'

//
export const UPDATE_DISPLAY_EMPLOYEE_AND_ETIME =
    'UPDATE_DISPLAY_EMPLOYEE_AND_ETIME'
export const UPDATE_DISPLAY_EMPLOYEE_AND_ETIME_FAILURE =
    'UPDATE_DISPLAY_EMPLOYEE_AND_ETIME_FAILURE'

// Notification

export const SEND_SMS = 'SEND_SMS'
export const SEND_SMS_FAILURE = 'SEND_SMS_FAILURE'

export const STATS_SMS = 'STATS_SMS'
export const STATS_SMS_FAILURE = 'STATS_SMS_FAILURE'

// Biz Numbers
export const FETCH_BIZNUMBERS = 'FETCH_BIZNUMBERS'
export const FETCH_BIZNUMBERS_FAILURE = 'FETCH_BIZNUMBERS_FAILURE'
export const UPDATE_BIZNUMBER = 'UPDATE_BIZNUMBER'
export const UPDATE_BIZNUMBER_FAILURE = 'UPDATE_BIZNUMBER_FAILURE'
export const REMOVE_BIZNUMBER = 'REMOVE_BIZNUMBER'
export const REMOVE_BIZNUMBER_FAILURE = 'REMOVE_BIZNUMBER_FAILURE'

// Template
export const FETCH_TEMPLATES = 'FETCH_TEMPLATES'
export const FETCH_TEMPLATES_FAILURE = 'FETCH_TEMPLATES_FAILURE'
export const UPDATE_TEMPLATES = 'UPDATE_TEMPLATES'
export const UPDATE_TEMPLATES_FAILURE = 'UPDATE_TEMPLATES_FAILURE'
export const REMOVE_TEMPLATE = 'REMOVE_TEMPLATE'
export const REMOVE_TEMPLATE_FAILURE = 'REMOVE_TEMPLATE_FAILURE'

// Contact
export const FETCH_CONTACTS = 'FETCH_CONTACTS'
export const FETCH_CONTACTS_FAILURE = 'FETCH_CONTACTS_FAILURE'
export const UPDATE_CONTACTS = 'UPDATE_CONTACTS'
export const UPDATE_CONTACTS_FAILURE = 'UPDATE_CONTACTS_FAILURE'
export const REMOVE_CONTACT = 'REMOVE_CONTACT'
export const REMOVE_CONTACT_FAILURE = 'REMOVE_CONTACT_FAILURE'

//PayrollEmpDefaultWorkHour
export const FETCH_EMP_DEFAULT_WORKHOUR = 'FETCH_EMP_DEFAULT_WORKHOUR'
export const FETCH_EMP_DEFAULT_WORKHOUR_FAILURE =
    'FETCH_EMP_DEFAULT_WORKHOUR_FAILURE'

//PayrollEmpNormalWorkingHour
export const FETCH_EMP_NORMAL_WORKHOUR = 'FETCH_EMP_NORMAL_WORKHOUR'
export const FETCH_EMP_NORMAL_WORKHOUR_FAILURE =
    'FETCH_EMP_NORMAL_WORKHOUR_FAILURE'

// Customization Colors
export const FETCH_COLORS = 'FETCH_COLORS'
export const FETCH_COLORS_FAILURE = 'FETCH_COLORS_FAILURE'
export const UPDATE_COLORS = 'UPDATE_COLORS'
export const UPDATE_COLORS_FAILURE = 'UPDATE_COLORS_FAILURE'
export const REMOVE_COLOR = 'REMOVE_COLOR'
export const REMOVE_COLOR_FAILURE = 'REMOVE_COLOR_FAILURE'
export const REMOVE_COLORS = 'REMOVE_COLORS'
export const REMOVE_COLORS_FAILURE = 'REMOVE_COLORS_FAILURE'

// employee leave
// Employee
export const FETCH_EMPLOYEE_LEAVE = 'FETCH_EMPLOYEE_LEAVE'
export const FETCH_EMPLOYEE_LEAVE_WEEKLY = 'FETCH_EMPLOYEE_LEAVE_WEEKLY'
export const FETCH_EMPLOYEE_LEAVE_FAILURE = 'FETCH_EMPLOYEE_LEAVE_FAILURE'

// week roster
export const UPDATE_WEEK_EVENTS = 'UPDATE_WEEK_EVENTS'
export const UPDATE_WEEK_EVENTS_FAILURE = 'UPDATE_WEEK_EVENTS_FAILURE'
export const SELECT_DATE_RANGE_FILTER = 'SELECT_DATE_RANGE_FILTER'

// Edit mode (set by parent window via postMessage)
export const SET_EDIT_MODE = 'SET_EDIT_MODE'
